import { gql } from '@apollo/client';

export default gql`
  query issueTypes {
    issueTypes
  }
`;
